import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { connect } from 'react-redux';
import { useDimensions } from 'components/shared/hooks';
import AskTheExpert from './AskTheExpert';
import HeaderBackground from './HeaderBackground';
import SearchBox from './SearchBox';
import Welcome from './Welcome';

export const WelcomeLearnHeader = ({ learnHeaderStyle = 'default' }) => {
  const [ref, dimensions] = useDimensions();

  const getBackground = (headerStyle, parentDimensions) => {
    if (!headerStyle || headerStyle === 'default') {
      return null;
    }
    const svgString = encodeURIComponent(
      ReactDOMServer.renderToStaticMarkup(
        <HeaderBackground
          type={headerStyle}
          parentDimensions={parentDimensions}
        />,
      ),
    );
    return {
      background: `url('data:image/svg+xml;utf8, ${svgString}') white no-repeat`,
    };
  };

  return (
    <div
      ref={ref}
      className="WelcomeLearnHeader"
      style={getBackground(learnHeaderStyle, dimensions)}
    >
      <div className="WelcomeLearnHeader-wrapper">
        <Welcome />
        <div className="WelcomeLearnHeader-search">
          <SearchBox />
          <AskTheExpert showSimpleVersion className="mt-8" />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  learnHeaderStyle: state.meta.settings.learn_header_style,
});

export default connect(mapStateToProps)(WelcomeLearnHeader);
